import { LineItem, Lot, ZeroStartingPrice } from 'types';
import { updateZeroStartingPricesByLineItems } from './updateZeroStartingPricesByLineItems';

/**
 * Finds the line items across these lots whose `negotiation_starting_price` is zero.
 *
 * @param lots - The lots whose line items are checked
 * @returns One entry per line item with a zero `negotiation_starting_price`
 */
export const updateZeroStartingPricesByLots = (
  lots: Lot[] = [],
): ZeroStartingPrice[] => {
  if (!lots || !Array.isArray(lots)) {
    return [];
  }

  const lineItems = lots.reduce<LineItem[]>((allLineItems, lot) => {
    if (!lot || !Array.isArray(lot.line_items)) {
      return allLineItems;
    }

    const validLineItems = lot.line_items.filter(Boolean);

    return [...allLineItems, ...validLineItems];
  }, []);

  return updateZeroStartingPricesByLineItems(lineItems);
};
